<template>
	<div class='knd-icon knd-svg-icon knd-icon-expand' >
    <svg viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle class='circle' cx="15" cy="15" r="15" />
      <path class='icon' d="M13.4156 16.2489C13.5856 16.0796 13.8136 15.9812 14.0535 15.9739C14.2933 15.9666 14.527 16.0508 14.7069 16.2095C14.8869 16.3682 14.9997 16.5895 15.0225 16.8283C15.0452 17.0672 14.9762 17.3058 14.8294 17.4956L14.7511 17.5844L10.2243 22.1111H12.6667C12.9074 22.1114 13.1389 22.2036 13.314 22.3688C13.489 22.534 13.5943 22.7599 13.6084 23.0002C13.6225 23.2405 13.5444 23.4771 13.3899 23.6617C13.2354 23.8463 13.0162 23.965 12.7772 23.9934L12.6667 24H7.94444C7.71312 24 7.48985 23.915 7.31698 23.7613C7.14412 23.6076 7.03368 23.3958 7.00661 23.1661L7 23.0556V18.3333C7.00027 18.0926 7.09244 17.8611 7.25769 17.686C7.42294 17.511 7.64879 17.4057 7.8891 17.3916C8.1294 17.3775 8.36602 17.4556 8.55062 17.6101C8.73521 17.7646 8.85385 17.9838 8.88228 18.2228L8.88889 18.3333V20.7757L13.4156 16.2489ZM23.0556 7C23.2869 7.00003 23.5102 7.08496 23.683 7.23868C23.8559 7.39239 23.9663 7.60421 23.9934 7.83394L24 7.94444V12.6667C23.9997 12.9074 23.9076 13.1389 23.7423 13.314C23.5771 13.489 23.3512 13.5943 23.1109 13.6084C22.8706 13.6225 22.634 13.5444 22.4494 13.3899C22.2648 13.2354 22.1462 13.0162 22.1177 12.7772L22.1111 12.6667V10.2243L17.5844 14.7511C17.4144 14.9204 17.1864 15.0188 16.9465 15.0261C16.7067 15.0334 16.473 14.9492 16.2931 14.7905C16.1131 14.6318 16.0003 14.4105 15.9775 14.1717C15.9548 13.9328 16.0238 13.6942 16.1706 13.5044L16.2489 13.4156L20.7757 8.88889H18.3333C18.0926 8.88862 17.8611 8.79645 17.686 8.6312C17.511 8.46595 17.4057 8.2401 17.3916 7.99979C17.3775 7.75949 17.4556 7.52286 17.6101 7.33827C17.7646 7.15367 17.9838 7.03504 18.2228 7.00661L18.3333 7H23.0556Z" />
    </svg>
	</div>
</template>
<script>

export default {
  props: [],
  setup () {

    return {
    }
  }
}
</script>


<style lang="scss">

$default-circle-bg: #FFF;
$default-icon-bg: #000;
$default-icon-size: 25px;

.knd-icon-expand {
  width: var(--icon-expand-size, $default-icon-size);
  height: var(--icon-expand-size, $default-icon-size);

  .circle {
    fill: var(--icon-expand-circle-bg, $default-circle-bg);
  }

  .icon {
    fill: var(--icon-expand-color, $default-icon-bg);
  }
}

</style>

<!-- 
import expandIcon from '@/components/icons/expand'; 
  --icon-expand-circle-bg: #FFF;
  --icon-expand-color: #310190;
  --icon-expand-size: 30px;

  <expandIcon />
-->
